export class GeoPt {
    latitude: number;
    longitude: number;
}
